import { defineMessages } from "react-intl";

export default defineMessages({
  nodata: {
    id: "KendoDropdowns.nodata",
    defaultMessage: "NO DATA FOUND.",
  },
  clear: {
    id: "KendoDropdowns.clear",
    defaultMessage: "clear",
  },
});